import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Zap } from 'lucide-react';
import { ROUTES } from '@/routes';

export function BrandMark() {
  const { t } = useTranslation('common');
  const name = t('brand.name');
  return (
    <Link
      to={ROUTES.home}
      className="inline-flex items-center gap-2 font-semibold tracking-tight text-foreground"
      aria-label={name}
    >
      <span
        aria-hidden="true"
        className="flex h-8 w-8 items-center justify-center rounded-md bg-brand text-brand-foreground shadow-soft"
      >
        <Zap className="h-4 w-4" />
      </span>
      <span className="text-base">{name}</span>
    </Link>
  );
}
